import React from "react";
import { useTranslation } from "react-i18next";

const ProofItem = ({ label, text }) => (
  <div className="proof-item">
    <div className="proof-title">{label}</div>
    <div className="proof-text">{text}</div>
  </div>
);

export default function ProofSection() {
  const { t } = useTranslation();
  const badges = t('proof.badges', { returnObjects: true });
  const kpis   = t('proof.kpis',   { returnObjects: true });

  return (
    <section id="proof" className="proof-section">
      <div className="container py-5">
        <div className="section-sticky-head text-center">
          <div className="section-eyebrow section-eyebrow--center">{t('nav.proof')}</div>
          <h2>{t('proof.heading')}</h2>
        </div>
        <div className="text-center mb-4">
          <p className="text-muted mb-0">{t('proof.description')}</p>
        </div>

        <div className="proof-grid">
          <div className="proof-card">
            <div className="proof-badges">
              {Array.isArray(badges) && badges.map((b, i) => (
                <span key={i} className="proof-badge">{b}</span>
              ))}
            </div>

            <div className="mt-2 mb-2 d-flex justify-content-center">
              <a
                rel="nofollow noopener noreferrer"
                href="https://www.exali.de/siegel/Alexander-Aprelkin"
                target="_blank"
                title={t('proof.insurance')}
              >
                <img
                  src="https://www.exali.de/siegel/siegel_de-2_1c3b2964baab89ed5848c513b9a0accb.png"
                  width="90" height="90"
                  alt={t('proof.insurance')}
                  loading="lazy"
                />
              </a>
            </div>

            <div className="mb-2 d-flex justify-content-center flex-wrap" style={{ gap: "12px" }}>
              <a
                rel="nofollow noopener noreferrer"
                href="https://www.credly.com/badges/42082e7a-941f-4f83-a7ef-8fe043866e91/public_url"
                target="_blank"
                title="Claude Partner Badge - Claude Code (Issuer: Anthropic)"
              >
                <img
                  src="https://images.credly.com/size/340x340/images/d8bc1ecf-6369-4bf9-8920-84169b35d918/blob"
                  width="130" height="130"
                  alt="Claude Partner Badge - Claude Code"
                  loading="lazy"
                  style={{ borderRadius: "50%" }}
                />
              </a>
              <img
                src="https://artifacts.credential.net/v26kb8aq/badge/116c82e4dfc59e9ddb50ef01c96ff37b/tiny.png"
                width="130" height="130"
                alt="OpenAI Partner Network - Technical Practitioner"
                title="OpenAI Partner Network - Technical Practitioner"
                loading="lazy"
                style={{ borderRadius: "50%" }}
              />
              <img
                src="https://artifacts.credential.net/7afs59zl/badge/b8082528b25b71de893e2191b3f184ae/tiny.png"
                width="130" height="130"
                alt="OpenAI Partner Network - Codex Solutions Practitioner"
                title="OpenAI Partner Network - Codex Solutions Practitioner"
                loading="lazy"
                style={{ borderRadius: "50%" }}
              />
            </div>

            <ProofItem label={t('proof.education.label')}     text={t('proof.education.text')} />
            <ProofItem label={t('proof.certifications.label')} text={t('proof.certifications.text')} />
            <ProofItem label={t('proof.value.label')}         text={t('proof.value.text')} />
          </div>

          <div className="proof-card">
            <div className="proof-kpis">
              {Array.isArray(kpis) && kpis.map((kpi, i) => (
                <div key={i} className="kpi">
                  <div className="kpi-v">{kpi.v}</div>
                  <div className="kpi-k">{kpi.k}</div>
                </div>
              ))}
            </div>
            <div className="proof-footer">
              <a href="#contact" className="offer-btn">{t('proof.cta')}</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
